import { render, staticRenderFns } from "./Celiane.vue?vue&type=template&id=379a6070&scoped=true"
import script from "./Celiane.vue?vue&type=script&lang=js"
export * from "./Celiane.vue?vue&type=script&lang=js"
import style0 from "./Celiane.vue?vue&type=style&index=0&id=379a6070&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "379a6070",
  null
  
)

export default component.exports